import { RevolvaService, ProductInfo, ProductList, PiecesInfo } from './revolva.service';
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { RoughnessMipmapper } from "three/examples/jsm/utils/RoughnessMipmapper.js";
import * as THREE from "three";

export function loadGround(service: RevolvaService) {
    const { scene } = service
    const loader = new THREE.TextureLoader();
    const groundTexture = loader.load('../../textures/ground.jpg');
    groundTexture.wrapS = groundTexture.wrapT = THREE.RepeatWrapping;
    groundTexture.repeat.set(1, 1);
    groundTexture.anisotropy = 16;
    groundTexture.encoding = THREE.sRGBEncoding;

    const groundMaterial = new THREE.MeshLambertMaterial({ map: groundTexture });

    const mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(1.5, 1.5), groundMaterial);
    mesh.position.y = - 0;
    mesh.rotation.x = - Math.PI / 2;
    mesh.receiveShadow = true;
    scene.add(mesh);
}


export function renderModel(service: RevolvaService) {
    const { renderer, canvas, scene, camera, animation, controls } = service
    if (animation) {
        //console.log("animation");
        setTimeout(function () {
            requestAnimationFrame(() => renderModel(service));
            controls.update();
            // stats.update();
        }, 1000 / 10);
    }

    camera.aspect = canvas.clientWidth / canvas.clientHeight;
    camera.updateProjectionMatrix();
    const pixelRatio = window.devicePixelRatio;
    const width = canvas.clientWidth * pixelRatio | 0;
    let height = canvas.clientHeight * pixelRatio | 0;

    // Ugly. I don't like this, but I'm getting out of ideas.
    // At least, this ensures that the two sides of the shop are aligned.
    const otherSideHeight = document.getElementById('shop-options').clientHeight;
    if (otherSideHeight < height) {
        height = otherSideHeight;
    }

    renderer.setSize(width, height, false);
    renderer.render(scene, camera);
    controls.update();
}


export function startLoad3d(service: RevolvaService) {

    const { scene, camera, controls, productId, productsInfo, productsList, roughnessMipmapper, pieces, piecesInScene } = service
    const productFolder = productsList[productId].product;
    const loader = new GLTFLoader();

    // This function will stack all loaders in an array of Promises
    // and return a promise of all.
    const promises: Promise<void>[] = [];

    productsInfo.forEach((item) => {
        if (item.product == productFolder) {

            promises.push(new Promise((resolve, reject) => {
                const path =
                    "../../productsList/" +
                    item.product +
                    "/" +
                    item.piece +
                    "/" +
                    item.spec +
                    "/" +
                    //service.stats = Stats();
                    item.file;

                loader.load(path, async (gltf) => {
                    const materialFunction = (child: THREE.Object3D): void => {
                        if (child instanceof THREE.Mesh) {
                            roughnessMipmapper.generateMipmaps(
                                (child as any).material // eslint-disable-line @typescript-eslint/no-explicit-any

                            );
                            // child.material.shading = THREE.SmoothShading;
                            child.castShadow = true;
                            child.receiveShadow = true;
                            child.geometry.computeVertexNormals(true);
                        }
                    };

                    gltf.scene.traverse(materialFunction);
                    roughnessMipmapper.dispose();
                    pieces[item.id] = gltf.scene;

                    if (item.default == 1) {
                        scene.add(gltf.scene);
                        piecesInScene[item.piece] = gltf.scene;
                    }
                    if (item.lookAt == 1) {
                        camera.lookAt(gltf.scene.position);
                        const helper = new THREE.BoxHelper(gltf.scene);
                        helper.geometry.computeBoundingBox();
                        const center = helper.geometry.boundingBox.getCenter(new THREE.Vector3);
                        gltf.scene.localToWorld(center);

                        controls.target.set(center.x, center.y, center.z);
                        controls.update();
                    }
                    resolve()
                }, null, reject);
            }));
        } //end of product
    }); //end of for each productsInfo
    return Promise.all(promises);
}

export function changePiecesInScene(service: RevolvaService, choiceUuid: string, type: string) {
    const { scene, productsInfo, pieces, piecesInScene, piecesInfo } = service

    if (type === 'shop.option.bag.type') {
        const item = productsInfo.filter(
            function (item) { return item.uuid == choiceUuid }
        );
        const product = item[0]
        const piece = product.piece
        const id = product.id
        scene.remove(piecesInScene[piece]);
        piecesInScene[piece] = pieces[id];
        scene.add(piecesInScene[piece]);
        renderModel(service);
    }
    else if (type === 'shop.option.bag.card') {

        const textureLoader = new THREE.TextureLoader();
        textureLoader.load(choiceUuid,

            // onLoad callback
            function (texture) {
                texture.flipY = false;
                //const id = product.id
                // scene.remove(piecesInScene[piece]);
                piecesInScene["default"].children.forEach((child) => {
                    if (child.name === "Card") {
                        child.traverse((obj) => {
                            if ((obj as THREE.Mesh).isMesh) {
                                // note: for a multi-material mesh, `o.material` may be an array,
                                // in which case you'd need to set `.map` on each value.
                                ((obj as any).material as any).map = texture; // eslint-disable-line @typescript-eslint/no-explicit-any
                                ((obj as any).material as any).flatShading = true; // eslint-disable-line @typescript-eslint/no-explicit-any
                            }
                        });
                    }
                })
                renderModel(service);
            },

            // onProgress callback currently not supported
            undefined,

            // onError callback
            null
        );   
    }
    if (type === 'shop.option.bag.color') {
        const item = piecesInfo.filter(
            function (item) { return item.uuid == choiceUuid }
        );
        const product = item[0]
        const path =
            "../../productsList/" +
            product.product +
            "/" +
            product.piece +
            "/" +
            product.color +
            "/" +
            product.file;

        const textureLoader = new THREE.TextureLoader();
        textureLoader.load(path,

            // onLoad callback
            function (texture) {
                texture.flipY = false;
                const piece = product.piece
                //const id = product.id
                // scene.remove(piecesInScene[piece]);
                piecesInScene[piece].children.forEach((child) => {
                    if (child.name !== "Card") {
                        child.traverse((obj) => {
                            if ((obj as THREE.Mesh).isMesh) {
                                const meshBasicMaterial = new THREE.MeshBasicMaterial();
                                meshBasicMaterial.map = texture;
                                // note: for a multi-material mesh, `o.material` may be an array,
                                // in which case you'd need to set `.map` on each value.
                               ((obj as any).material as any).map.image = meshBasicMaterial.map.image; // eslint-disable-line @typescript-eslint/no-explicit-any
                                ((obj as any).material as any).flatShading = true; // eslint-disable-line @typescript-eslint/no-explicit-any
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                ((obj as any).material as any).map.needsUpdate = true;
                            }
                        });
                    }
                })
                renderModel(service);
            },

            // onProgress callback currently not supported
            undefined,

            // onError callback
            null
        );
    }
}

export function init(service: RevolvaService) {
    const { scene, canvas, camera, renderer, controls, light, ground } = service;

    camera.position.set(0.4, 0.3, 0);

    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
    //renderer.toneMapping = THREE.ACESFilmicToneMapping;
    //renderer.toneMappingExposure = 0.8;
    //renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.domElement.style.outline = "none";
    renderer.shadowMap.enabled = true;
    //renderer.shadowMap.type = THREE.PCFShadowMap; 
    renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMappingExposure = 2.3;

    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    light.position.set(2, 2, 2);
    /* light.castShadow = true;
    light.shadow.bias = -0.0001;
    light.shadow.mapSize.width = 1024 * 2;
    light.shadow.mapSize.height = 1024 * 2; */


    scene.add(light);

    if (ground) {
        loadGround(service);
    }

    new RGBELoader()
        .setDataType(THREE.UnsignedByteType)
        .load("../../textures/Gray6.hdr", (texture) => {
            const envMap = pmremGenerator.fromEquirectangular(texture).texture;
            scene.environment = envMap;
            renderer.render(scene, camera);
            //renderModel(service);
            texture.dispose();
            pmremGenerator.dispose();
        });


    controls.addEventListener("change", () => renderer.render(scene, camera)); // use if there is no animation loop
    controls.minDistance = 0.35;
    controls.maxDistance = 1;
    controls.minPolarAngle = Math.PI / 2;
    controls.maxPolarAngle = Math.PI / 2;
    controls.target.set(0, 0, 0);
    controls.autoRotate = true
    controls.update();

    renderModel(service);
}

export function setProductId(service: RevolvaService, productId: number) {
    service.productId = productId;
}

export function setproductsListJson(service: RevolvaService, productsListJson: ProductList[]) {
    service.productsList = productsListJson;
}

export function setProductsInfo(service: RevolvaService, productsInfo: ProductInfo[]) {
    service.productsInfo = productsInfo;
}

export function setPiecesInfo(service: RevolvaService, piecesInfo: PiecesInfo[]) {
    service.piecesInfo = piecesInfo;
}

export function setCanvas(service: RevolvaService, canvas: HTMLCanvasElement) {
    service.canvas = canvas;
}

export function setMainObjects(service: RevolvaService) {
    service.camera = new THREE.PerspectiveCamera(
        45,
        service.canvas.clientWidth / service.canvas.clientHeight,
        0.25,
        100
    );
    service.scene = new THREE.Scene();
    service.renderer = new THREE.WebGLRenderer({ canvas: service.canvas, antialias: true, alpha: true });
    service.controls = new OrbitControls(service.camera, service.renderer.domElement);
    service.roughnessMipmapper = new RoughnessMipmapper(service.renderer);
    service.light = new THREE.DirectionalLight(0xffa95c, 3);
    //service.light = new THREE.DirectionalLight(0xffffff, 3);
}

export function setCanvafullScreen(service: RevolvaService, status: boolean) {
    service.canvaFullScreen = status
}